/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import { useEffect, useState } from "react";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import ReportModal from "../../ReportModal";
import { getRequest } from '../../../../../helpers/axiosClient';
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import { Button, Box, FormControlLabel, Switch } from "@mui/material";
import productActions from "../../../../Product/Product/redux/actions";
import clsx from "clsx";
import DateIcon from "../../Icons/Date";
import { Space, Col, Row } from 'antd';
import moment from 'moment';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';

export const NetOrderReport = (props) => {
    const { visible, onNetOrderVisible, title, onMenuTitle } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);

    const [filterValues, setFilterValues] = useState({
        date: new Date()
    });

    const dispatch = useDispatch();
    const [reportOpen, setReportOpen] = useState(false);
    const [netOrderData, setNetOrderData] = useState([]);
    const [loading, setLoading] = useState(false);

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const netOrderFilter = (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            let url = `${process.env.REACT_APP_API_URL}/netOrderReport`;

            if (filterValues?.product?.id) {
                url += `?productId=${filterValues?.product?.id}`;
            }

            if (filterValues?.date) {
                url += `${filterValues?.product?.id ? '&' : '?'}date=${moment(filterValues?.date).format("YYYY-MM-DD")}`;
            }

            let response = getRequest(url);
            response.then(payload => {
                if (filterValues?.type === 'quote') {
                    setNetOrderData(payload.data.quoteData);
                } else if (filterValues?.type === 'transfer') {
                    setNetOrderData(payload.data.transferData);
                } else {
                    const quoteData = payload.data.quoteData || [];
                    const transferData = payload.data.transferData || [];

                    const map = {};

                    // add quote data
                    quoteData.forEach(item => {
                        map[item.productId] = {
                            ...item,
                            totalQuantity: Number(item?.quoteQuantity || 0),
                            transferQuantity: 0,
                            transferUnitName: ''
                        };
                    });

                    // merge transfer data
                    transferData.forEach(item => {
                        if (map[item.productId]) {
                            console.log(item?.transferQuantity);
                            map[item.productId].totalQuantity = (map[item.productId].quoteQuantity || 0) + Number(item?.transferQuantity || 0);
                            map[item.productId].transferQuantity = Number(item.transferQuantity || 0);
                            map[item.productId].transferUnitName = item.transferUnitName || '';
                        } else {
                            map[item.productId] = {
                                ...item,
                                totalQuantity: 0,
                                transferQuantity: Number(item.transferQuantity) || 0
                            };
                        }
                    });

                    const combined = Object.values(map);

                    setNetOrderData(combined);
                }
                setReportOpen(true);
                setLoading(false);
            }).catch(error => {
                // Handle any errors
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (visible) {
            productApi();
        }
    }, [visible])

    const handleClose = () => {
        setFilterValues({ date: new Date() });
        onNetOrderVisible(false);
        onMenuTitle('');
    }

    const netOrderTitle = (values) => {
        let v = '';
        if (values?.product?.productName) {
            v = `Product : ${values?.product?.productName} `;
        }
        if (values?.date) {
            v += `${values?.product?.productName ? ' - ' : ''}Date : ${moment(values?.date).format("DD-MM-YYYY")} `;
        }
        return v;
    }

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }] };
        let or = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const changeHandler = (e, name = '', relation = false) => {
        setFilterValues({
            ...filterValues,
            [name]: e
        });
    }

    const netOrderMainTitle = (value) => {
        switch (value) {
            case "quote": return 'Sales Quote';
            case "transfer": return 'Stock Transfer';
            default: return 'All Orders';
        };
    }

    const classes = customStyles();
    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => netOrderFilter(e)}>
                        <div className={classes.customFormFlex}>
                            <AutoCompleteComponent
                                name={`Product `}
                                heads={[{ key: "productName", name: "Product Name" },
                                { key: "code", name: "Product Code" },
                                { key: "productId", name: "Product ID" }]}
                                details={myProductdetails}
                                id={idNamingConversion("Product", "stockValue", "DropDown")}
                                parentValue={customObject(myProductdetails, filterValues?.product?.id)}
                                onChange={(data) => changeHandler(data, 'product', true)}
                                position="bottom"
                                searchType={(s) => productApi(s)}
                            />
                            <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={filterValues?.date}
                                        format='dd/MM/yyyy'
                                        label="Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('Date', 'productAnalysis', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ? changeHandler(new Date(), 'date') : changeHandler(newValue, 'date')
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <AutoCompleteComponent
                                name={["Type "]}
                                heads={[{ 'key': 'label', 'name': 'Type' }]}
                                details={[{ "id": "quote", "label": "Sales Quote" }, { "id": "transfer", "label": "Stock Transfer" }]}
                                parentValue={customObject([{ "id": "quote", "label": "Sales Quote" }, { "id": "transfer", "label": "Stock Transfer" }], filterValues?.type)}
                                onChange={(data) => changeHandler(data.id, 'type')}
                                position={'bottom'}
                                id={idNamingConversion('Type', 'productAnalysis', 'DropDown')}
                                customClasses={classes.margin20t}
                            />
                            <FormControlLabel
                                classes={{
                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                }}
                                id={idNamingConversion('Cost Details', 'stockValue', 'Radio')}
                                control={<Switch size='small'
                                    className={clsx(classes.customSwitch)}
                                    onChange={(e) => changeHandler(!filterValues.costDetails, 'costDetails')}
                                    checked={filterValues.costDetails}
                                />}
                                label="Enable Cost Details"
                                labelPlacement="top"
                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: loading })}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{netOrderMainTitle(filterValues?.type)}</h4>
                            <p className={classes.downloadsHeading}>{netOrderTitle(filterValues)}</p>
                        </div>
                        {
                            filterValues?.type === 'quote' ? <>
                                <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                                    <Col span={filterValues?.costDetails ? 3 : 5}><h6 style={{ fontSize: 14 }}>Product ID</h6></Col>
                                    <Col span={filterValues?.costDetails ? 7 : 9}><h6 style={{ fontSize: 14 }}>Product Description</h6></Col>
                                    <Col span={filterValues?.costDetails ? 3 : 5}><h6 style={{ fontSize: 14 }}>Unit</h6></Col>
                                    <Col span={filterValues?.costDetails ? 3 : 5}><h6 style={{ fontSize: 14 }}>Qty.</h6></Col>
                                    {
                                        filterValues?.costDetails ? <>
                                            <Col span={4}><h6 style={{ fontSize: 14 }}>Cost Price</h6></Col>
                                            <Col span={4}><h6 style={{ fontSize: 14 }}>Cost Amount</h6></Col>
                                        </> : null
                                    }
                                </Row>
                                {
                                    netOrderData?.length > 0 ? netOrderData.map((data, i) => (
                                        <Row className={clsx(classes.bill, 'no-break')}>
                                            <Col span={filterValues?.costDetails ? 3 : 5}><p style={{ fontSize: 14 }}>{data?.productId || ''}</p></Col>
                                            <Col span={filterValues?.costDetails ? 7 : 9}><p style={{ fontSize: 14, padding: "0 5px" }}>{data?.description || '---'}</p></Col>
                                            <Col span={filterValues?.costDetails ? 3 : 5}><p style={{ fontSize: 14 }}>{data?.quoteUnitName || '---'}</p></Col>
                                            <Col span={filterValues?.costDetails ? 3 : 5}><p style={{ fontSize: 14 }}>{data?.quoteQuantity || '---'}</p></Col>
                                            {
                                                filterValues?.costDetails ? <>
                                                    <Col span={4}><p style={{ fontSize: 14 }}>{`₹ ${currencyFormat(data?.costPrice || 0)}`}</p></Col>
                                                    <Col span={4}><p style={{ fontSize: 14 }}>{`₹ ${currencyFormat((data?.quoteQuantity * data?.costPrice))}`}</p></Col>
                                                </> : null
                                            }
                                        </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                                }
                                <Row className={clsx(classes.bill)}>
                                    <Col span={filterValues?.costDetails ? 10 : 14}></Col>
                                    <Col span={filterValues?.costDetails ? 3 : 5}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>Total:</h6></Col>
                                    <Col span={filterValues?.costDetails ? 3 : 5}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>{(netOrderData?.length > 0 ? netOrderData.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.quoteQuantity || 0), 0) : 0)}</h6></Col>
                                    {
                                        filterValues?.costDetails ? <>
                                            <Col span={4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}></h6></Col>
                                            <Col span={4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>₹ {currencyFormat(netOrderData?.length > 0 ? netOrderData.reduce((a, v) => a = parseFloat(a) + parseFloat((v?.quoteQuantity * v?.costPrice)), 0) : 0)}</h6></Col>
                                        </> : null
                                    }
                                </Row>
                            </> : filterValues?.type === 'transfer' ? <>
                                <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                                    <Col span={filterValues?.costDetails ? 3 : 5}><h6 style={{ fontSize: 14 }}>Product ID</h6></Col>
                                    <Col span={filterValues?.costDetails ? 7 : 9}><h6 style={{ fontSize: 14 }}>Product Description</h6></Col>
                                    <Col span={filterValues?.costDetails ? 3 : 5}><h6 style={{ fontSize: 14 }}>Unit</h6></Col>
                                    <Col span={filterValues?.costDetails ? 3 : 5}><h6 style={{ fontSize: 14 }}>Qty.</h6></Col>
                                    {
                                        filterValues?.costDetails ? <>
                                            <Col span={4}><h6 style={{ fontSize: 14 }}>Cost Price</h6></Col>
                                            <Col span={4}><h6 style={{ fontSize: 14 }}>Cost Amount</h6></Col>
                                        </> : null
                                    }
                                </Row>
                                {
                                    netOrderData?.length > 0 ? netOrderData.map((data, i) => (
                                        <Row className={clsx(classes.bill, 'no-break')}>
                                            <Col span={filterValues?.costDetails ? 3 : 5}><p style={{ fontSize: 14 }}>{data?.productId || ''}</p></Col>
                                            <Col span={filterValues?.costDetails ? 7 : 9}><p style={{ fontSize: 14, padding: "0 5px" }}>{data?.description || '---'}</p></Col>
                                            <Col span={filterValues?.costDetails ? 3 : 5}><p style={{ fontSize: 14 }}>{data?.transferUnitName || '---'}</p></Col>
                                            <Col span={filterValues?.costDetails ? 3 : 5}><p style={{ fontSize: 14 }}>{data?.transferQuantity || '---'}</p></Col>
                                            {
                                                filterValues?.costDetails ? <>
                                                    <Col span={4}><p style={{ fontSize: 14 }}>{`₹ ${currencyFormat(data?.costPrice || 0)}`}</p></Col>
                                                    <Col span={4}><p style={{ fontSize: 14 }}>{`₹ ${currencyFormat((data?.transferQuantity * data?.costPrice))}`}</p></Col>
                                                </> : null
                                            }
                                        </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                                }
                                <Row className={clsx(classes.bill)}>
                                    <Col span={filterValues?.costDetails ? 10 : 14}></Col>
                                    <Col span={filterValues?.costDetails ? 3 : 5}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>Total:</h6></Col>
                                    <Col span={filterValues?.costDetails ? 3 : 5}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>{(netOrderData?.length > 0 ? netOrderData.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.transferQuantity || 0), 0) : 0)}</h6></Col>
                                    {
                                        filterValues?.costDetails ? <>
                                            <Col span={4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}></h6></Col>
                                            <Col span={4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>₹ {currencyFormat(netOrderData?.length > 0 ? netOrderData.reduce((a, v) => a = parseFloat(a) + parseFloat((v?.transferQuantity * v?.costPrice)), 0) : 0)}</h6></Col>
                                        </> : null
                                    }
                                </Row>
                            </> : <>
                                <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                                    <Col span={2}><h6 style={{ fontSize: 14 }}>Product ID</h6></Col>
                                    <Col span={filterValues?.costDetails ? 3 : 5}><h6 style={{ fontSize: 14 }}>Product Description</h6></Col>
                                    <Col span={3}><h6 style={{ fontSize: 14 }}>Quote Unit</h6></Col>
                                    <Col span={3}><h6 style={{ fontSize: 14 }}>Quote Qty.</h6></Col>
                                    <Col span={3}><h6 style={{ fontSize: 14 }}>Transfer Unit</h6></Col>
                                    <Col span={filterValues?.costDetails ? 2 : 4}><h6 style={{ fontSize: 14 }}>Transfer Qty.</h6></Col>
                                    <Col span={filterValues?.costDetails ? 2 : 4}><h6 style={{ fontSize: 14 }}>Qty.</h6></Col>
                                    {
                                        filterValues?.costDetails ? <>
                                            <Col span={3}><h6 style={{ fontSize: 14 }}>Cost Price</h6></Col>
                                            <Col span={3}><h6 style={{ fontSize: 14 }}>Cost Amount</h6></Col>
                                        </> : null
                                    }
                                </Row>
                                {
                                    netOrderData?.length > 0 ? netOrderData.map((data, i) => (
                                        <Row className={clsx(classes.bill, 'no-break')}>
                                            <Col span={2}><p style={{ fontSize: 14 }}>{data?.productId || ''}</p></Col>
                                            <Col span={filterValues?.costDetails ? 3 : 5}><p style={{ fontSize: 14, padding: "0 5px" }}>{data?.description || '---'}</p></Col>
                                            <Col span={3}><p style={{ fontSize: 14 }}>{data?.quoteUnitName || '---'}</p></Col>
                                            <Col span={3}><p style={{ fontSize: 14 }}>{data?.quoteQuantity || '---'}</p></Col>
                                            <Col span={3}><p style={{ fontSize: 14 }}>{data?.transferUnitName || '---'}</p></Col>
                                            <Col span={filterValues?.costDetails ? 2 : 4}><p style={{ fontSize: 14 }}>{data?.transferQuantity || '---'}</p></Col>
                                            <Col span={filterValues?.costDetails ? 2 : 4}><p style={{ fontSize: 14 }}>{data?.totalQuantity || '---'}</p></Col>
                                            {
                                                filterValues?.costDetails ? <>
                                                    <Col span={3}><p style={{ fontSize: 14 }}>{`₹ ${currencyFormat(data?.costPrice || 0)}`}</p></Col>
                                                    <Col span={3}><p style={{ fontSize: 14 }}>{`₹ ${currencyFormat((data?.totalQuantity * data?.costPrice))}`}</p></Col>
                                                </> : null
                                            }
                                        </Row>)) : <Row className={classes.noBorder}><Col span={24} style={{ textAlign: "center", marginTop: 15 }}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</Col></Row>
                                }
                                <Row className={clsx(classes.bill)}>
                                    <Col span={filterValues?.costDetails ? 5 : 7}></Col>
                                    <Col span={3}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>Total:</h6></Col>
                                    <Col span={3}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>{(netOrderData?.length > 0 ? netOrderData.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.quoteQuantity || 0), 0) : 0)}</h6></Col>
                                    <Col span={3}></Col>
                                    <Col span={filterValues?.costDetails ? 2 : 4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>{(netOrderData?.length > 0 ? netOrderData.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.transferQuantity || 0), 0) : 0)}</h6></Col>
                                    <Col span={filterValues?.costDetails ? 2 : 4}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>{(netOrderData?.length > 0 ? netOrderData.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.totalQuantity || 0), 0) : 0)}</h6></Col>
                                    {
                                        filterValues?.costDetails ? <>
                                            <Col span={3}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}></h6></Col>
                                            <Col span={3}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>₹ {currencyFormat(netOrderData?.length > 0 ? netOrderData.reduce((a, v) => a = parseFloat(a) + parseFloat((v?.totalQuantity * v?.costPrice)), 0) : 0)}</h6></Col>
                                        </> : null
                                    }
                                </Row>
                            </>
                        }
                    </>
                }
                businessDetails={businessDetails}
                reportType={'landscape'}
                handleClose={() => { setReportOpen(false); }}
            />
        </>
    )
}
